import React from "react";

import { useIsNetworkFast } from "./isNetworkFast";
import { useFabricFeatureFlag } from "../next/hooks";
import { queryClient, queryClientDefaultOptions } from "../services/query";

export const useManageEnablingFreshData = () => {
  const fetchFreshCoreDataFF = useFabricFeatureFlag({
    key: "fetch-fresh-core-data",
    ignoreUserId: true,
    ignoreOperationId: true,
  });

  const isNetworkFast = useIsNetworkFast();

  React.useEffect(() => {
    const fetchFreshCoreData = fetchFreshCoreDataFF && isNetworkFast;

    queryClient.setDefaultOptions({
      ...queryClientDefaultOptions,
      queries: {
        ...queryClientDefaultOptions,
        staleTime: fetchFreshCoreData
          ? 30 * 1000 // 30 seconds
          : 5 * 60 * 1000, // 5 minutes
        refetchOnMount: fetchFreshCoreData,
        refetchOnReconnect: fetchFreshCoreData,
        refetchOnWindowFocus: fetchFreshCoreData,
      },
    });
  }, [fetchFreshCoreDataFF, isNetworkFast]);
};
